var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceSvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 35,
    viewBox: "0 0 86 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4527 35H2.54726C1.14898 35 0 33.808 0 32.3321V21.9899H0.812957C3.17595 21.9899 5.10537 19.9805 5.10537 17.4943C5.10537 15.0081 3.18679 12.9987 0.812957 12.9987H0V2.66786C0 1.19202 1.13814 0 2.54726 0H83.4527C84.851 0 86 1.19202 86 2.66786V13.0101H85.187C82.824 13.0101 80.8946 15.0195 80.8946 17.5057C80.8946 19.9919 82.8132 22.0013 85.187 22.0013H86V32.3435C86 33.808 84.8619 35.0114 83.4527 35.0114V35ZM1.62591 23.6361V32.3321C1.62591 32.8657 2.03781 33.2971 2.54726 33.2971H83.4527C83.9622 33.2971 84.3741 32.8657 84.3741 32.3321V23.6361C81.5016 23.216 79.2687 20.6276 79.2687 17.5057C79.2687 14.3837 81.4908 11.784 84.3741 11.3753V2.66786C84.3741 2.13428 83.9622 1.70289 83.4527 1.70289H2.54726C2.03781 1.70289 1.62591 2.13428 1.62591 2.66786V11.3639C4.49836 11.784 6.73128 14.3724 6.73128 17.4943C6.73128 20.6163 4.5092 23.216 1.62591 23.6247V23.6361Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.055 23.602H15.3159V11.3071H27.055V23.602ZM16.9418 21.8991H25.4291V13.01H16.9418V21.8991Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8641 23.602H37.125V11.3071H48.8641V23.602ZM38.7509 21.8991H47.2382V13.01H38.7509V21.8991Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6839 23.602H58.9448V11.3071H70.6839V23.602ZM60.5707 21.8991H69.058V13.01H60.5707V21.8991Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSvgIcon);
export default __webpack_public_path__ + "static/media/deviceSVGIcon.5a3cda4c3b0892dfc545110c2475df47.svg";
export { ForwardRef as ReactComponent };